import Api from "./baseApi";

export default {
  getProfitTable: () => Api.get("/api/mpproducts/profit-table?v=1"),
  updateDoviz: (body) => Api.post("/api/mpproducts/profit-table/update-doviz", body),
  saveOrder: (body) => Api.post("/api/mpproducts/profit-table/order", body),
};
